// @flow

import { getId } from '../routes';
import { getUiSetting } from '../uiStore';
import { FEEDBACK_LOADING, FEEDBACK_PREFIX } from './constants';
import type { State as RouterState } from '../router';
import type { State as RoutesState } from '../routes';
import type { State as UiStoreState } from '../uiStore';

type GlobalState = {
  router: RouterState,
  routes: RoutesState,
  uiSettings: UiStoreState,
};

export const getFAQFeedback = (state: GlobalState, id: string) => (
  getUiSetting(state, `${FEEDBACK_PREFIX}${id}`)
);

export const getFAQFeedbackForCurrentPath = (state: GlobalState) => (
  getFAQFeedback(state, getId(state).toString())
);

export const getLoadingFeedbackComplete = (state: GlobalState) => (
  getUiSetting(state, FEEDBACK_LOADING)
);

export const hasFAQFeedback = (state: GlobalState, url: string) => (
  Boolean(getFAQFeedback(state, url) !== undefined)
);
